import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const StarActiveIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='currentColor' {...props} ref={ref}>
        <path d='m8 11.74 3.713 2.24a.357.357 0 0 0 .533-.386l-.985-4.223 3.282-2.843a.357.357 0 0 0-.203-.626l-4.321-.373L8.33 1.55a.357.357 0 0 0-.658 0l-1.69 3.978-4.322.373a.357.357 0 0 0-.203.626L4.733 9.37l-.98 4.225a.357.357 0 0 0 .533.386L8 11.74Z' />
    </svg>
));
